import {FeedbackBase} from "../component/FeedbackBase";

export const GiveFeedback = () => <FeedbackBase admin={true}/>